import FacetCategoryViewModel from "./FacetCategoryViewModel";

export class FacetsViewModel {
  memberships: FacetCategoryViewModel;
  nationalities: FacetCategoryViewModel;
  appearances: FacetCategoryViewModel;
  eyeColors: FacetCategoryViewModel;
  hairColors: FacetCategoryViewModel;
  hairLengths: FacetCategoryViewModel;
  facialHairs: FacetCategoryViewModel;
  voiceStyle: FacetCategoryViewModel;
  beltNotes: FacetCategoryViewModel;
  disabilities: FacetCategoryViewModel;
  genders: FacetCategoryViewModel;
  heritageAndEthnicity: FacetCategoryViewModel;
  ethnicBackground: FacetCategoryViewModel;
  visasAndPermits: FacetCategoryViewModel;
}
